<script setup lang="ts"></script>
<template>
  <div class="divider my-3"></div>
</template>

<style scoped lang="scss">
  .divider {
    width: 100%;
    height: 2px;
    background-color: #796c66;
  }
</style>
